var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminUsers',{attrs:{"role":`administrator`,"roleName":`管理者`}})
}
var staticRenderFns = []

export { render, staticRenderFns }